var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        { staticClass: "btn-container" },
        [
          _c(
            "div",
            [
              _c(
                "md-radio",
                {
                  attrs: { "md-value": "maximizeAds" },
                  on: { change: _vm.maximizeAdsFunction },
                  model: {
                    value: _vm.adBreaksView,
                    callback: function($$v) {
                      _vm.adBreaksView = $$v
                    },
                    expression: "adBreaksView"
                  }
                },
                [_vm._v("Recommended")]
              ),
              _c(
                "md-radio",
                {
                  attrs: { "md-value": "customAds" },
                  model: {
                    value: _vm.adBreaksView,
                    callback: function($$v) {
                      _vm.adBreaksView = $$v
                    },
                    expression: "adBreaksView"
                  }
                },
                [_vm._v("Custom ads")]
              ),
              _c(
                "md-radio",
                {
                  attrs: { "md-value": "noAds" },
                  model: {
                    value: _vm.adBreaksView,
                    callback: function($$v) {
                      _vm.adBreaksView = $$v
                    },
                    expression: "adBreaksView"
                  }
                },
                [_vm._v("Pre-roll only")]
              )
            ],
            1
          ),
          _c(
            "md-button",
            { staticClass: "md-icon-button", on: { click: _vm.resetAdBreaks } },
            [_c("md-icon", { attrs: { "md-iconset": "fa fa-undo" } })],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c("transition-group", {
            attrs: {
              name: "fade",
              "enter-active-class": "animated fadeIn",
              "enter-leave-class": "animated fadeOut",
              mode: "out-in"
            }
          }),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.adBreaksView === "noAds",
                expression: 'adBreaksView === "noAds"'
              }
            ],
            key: "noAdsView"
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.adBreaksView === "maximizeAds",
                  expression: 'adBreaksView === "maximizeAds"'
                }
              ],
              key: "maximizeAdsView",
              attrs: { "md-flex": "100" }
            },
            _vm._l(_vm.recommendedAdBreaks, function(adBreak) {
              return _c(
                "md-button",
                {
                  key: adBreak.value,
                  ref: "adBreakButton",
                  refInFor: true,
                  staticClass: "md-primary md-raised btn-ads",
                  style: adBreak.checked
                    ? ""
                    : {
                        background: "#eee !important",
                        color: "black !important"
                      },
                  on: {
                    click: function($event) {
                      return _vm.toggleRecommendedAdBreak(adBreak)
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      adBreak.value === _vm.preRollValue
                        ? "Preroll"
                        : adBreak.value
                    )
                  )
                ]
              )
            }),
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.adBreaksView === "customAds",
                  expression: 'adBreaksView === "customAds"'
                }
              ],
              key: "customAdsView"
            },
            [
              _c("div", [
                _c(
                  "div",
                  [
                    _c(
                      "md-checkbox",
                      {
                        on: { change: _vm.handlePreRollChange },
                        model: {
                          value: _vm.preRollChecked,
                          callback: function($$v) {
                            _vm.preRollChecked = $$v
                          },
                          expression: "preRollChecked"
                        }
                      },
                      [_vm._v("Add Preroll")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "inputs" },
                  [
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "hour" } }, [
                          _vm._v("Hour")
                        ]),
                        _c(
                          "md-select",
                          {
                            attrs: { id: "hour", placeholder: "Hour" },
                            model: {
                              value: _vm.hourForCustomAdbreak,
                              callback: function($$v) {
                                _vm.hourForCustomAdbreak = $$v
                              },
                              expression: "hourForCustomAdbreak"
                            }
                          },
                          [
                            _vm._v(":"),
                            _vm._l(4, function(hour) {
                              return _c(
                                "md-option",
                                {
                                  key: hour,
                                  attrs: {
                                    value: (hour - 1)
                                      .toString()
                                      .padStart(2, "0")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      (hour - 1).toString().padStart(2, "0")
                                    ) + " "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _c("p", [_vm._v(":")]),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "minute" } }, [
                          _vm._v("Minute")
                        ]),
                        _c(
                          "md-select",
                          {
                            attrs: { id: "minute", placeholder: "Minutes" },
                            model: {
                              value: _vm.minuteForCustomAdbreak,
                              callback: function($$v) {
                                _vm.minuteForCustomAdbreak = $$v
                              },
                              expression: "minuteForCustomAdbreak"
                            }
                          },
                          _vm._l(60, function(minute) {
                            return _c(
                              "md-option",
                              {
                                key: minute,
                                attrs: {
                                  value: (minute - 1)
                                    .toString()
                                    .padStart(2, "0")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    (minute - 1).toString().padStart(2, "0")
                                  ) + " "
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c("p", [_vm._v(":")]),
                    _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "second" } }, [
                          _vm._v("Second")
                        ]),
                        _c(
                          "md-select",
                          {
                            attrs: { id: "second", placeholder: "Seconds" },
                            model: {
                              value: _vm.secondForCustomAdbreak,
                              callback: function($$v) {
                                _vm.secondForCustomAdbreak = $$v
                              },
                              expression: "secondForCustomAdbreak"
                            }
                          },
                          _vm._l(60, function(second) {
                            return _c(
                              "md-option",
                              {
                                key: second,
                                attrs: {
                                  value: (second - 1)
                                    .toString()
                                    .padStart(2, "0")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    (second - 1).toString().padStart(2, "0")
                                  )
                                )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-primary md-raised",
                        on: { click: _vm.addCustomAdBreak }
                      },
                      [
                        _c("md-icon", {
                          attrs: {
                            id: "add-icon-btn",
                            "md-iconset": "fa fa-plus"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._l(_vm.customAdBreaks, function(adBreak) {
                return _c(
                  "md-button",
                  {
                    key: adBreak.value,
                    ref: "customAdBreakButton",
                    refInFor: true,
                    staticClass: "md-primary md-raised btn-ads",
                    on: {
                      click: function($event) {
                        return _vm.deleteCustomAdBreak(adBreak)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        adBreak.value === _vm.preRollValue
                          ? "Preroll"
                          : adBreak.value
                      )
                    )
                  ]
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53559048", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53559048","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/MediaItemsRokuAdBreaks.vue
// module id = 902
// module chunks = 0